module.exports = __webpack_public_path__ + "static/media/Luenne.fb760f6f.png";